import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pre-enlistment-failed',
  templateUrl: './pre-enlistment-failed.component.html',
  styleUrls: ['./pre-enlistment-failed.component.scss']
})
export class PreEnlistmentFailedComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();
}